import React, { Component } from "react"
import { Table, Row, Icon } from "antd"
import { observer, inject } from "mobx-react"
import MaterialTip from "app/components/normal/MaterialTip/MaterialTip"
import FlexableFileName from "app/components/normal/FlexableFileName"
import Highlighter from "app/components/normal/HighLighter"
import highlightable from "app/utils/highlightable"
import warningIcon from "app/styles/images/sp/data-warning.svg"
import { PREPARE_RUN, RUNNING, FAIL, CONTROL_FAIL_QUALITY } from 'app/utils/const'

@inject("auth") @observer
class Index extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showEditModal: false,
      showDeleteModal: false,
      dataSingle: {},
      editedHistory: []
    }

    this.columns = []
  }

  componentDidMount() {
    const { store: { list } } = this.props
    list.getTableData()
      .then(
        res => {
          list.updateTableData(res)
          list.initPageIndex()
        }
      )
  }

  onPaginChange = selectedPageNumber => {
    let {
      store: {
        list
      },
    } = this.props

    list.changePagin(selectedPageNumber)

    document.getElementById("contentTop").scrollIntoView(true)
  }

  render() {
    const {
      store: {
        list: {
          tableData,
          totalCount,
          queryMap,
          currentPageIndex,
        }
      },
    } = this.props

    const renderContent = (text, record, index) => {
      const obj = {
        children: text || '-',
        props: {},
      }
      if (record.state === PREPARE_RUN || record.state === RUNNING) {
        obj.props.colSpan = 0
      }
      return obj
    }

    const columns = [
      {
        title: "文件名称",
        dataIndex: "filename",
        width: "24.1%",
        sorter: (a, b) => a.filename.localeCompare(b.filename),
        render: (text, record, index) => {
          const { list: { queryMap: { keywords } } } = this.props.store
          return (
            <FlexableFileName filename={text} keywords={keywords} />
          )
        }
      }, {
        width: "12.71%",
        title: "样本名称",
        dataIndex: "sampleName",
        sorter: (a, b) => a.sampleName.localeCompare(b.sampleName),
        render: (text) => {
          const { list: { queryMap: { keywords } } } = this.props.store

          return (
            <MaterialTip title={text}>
              <div className="sample-name ellipsis">
                <Highlighter
                  highlightStyle={{ fontWeight: "normal" }}
                  searchWords={highlightable(text, keywords) ? [text] : []}
                  textToHighlight={text || ''}
                />
              </div>
            </MaterialTip>
          )
        }
      },{
        title: (<div className="ta-r">外部编号</div>),
        className: "ta-r",
        dataIndex: "hospitalSampleName",
        render: renderContent
      },{
        title: (<div className="ta-r">Total_Reads</div>),
        className: "ta-r",
        dataIndex: "totalReads",
        render: (text, record, index) => {
          const stateData = [
            {
              text: "数据准备运行",
              className: "pre-run azf-state-element"
            },
            {
              text: "数据正在运行",
              className: "running azf-state-element"
            },
          ]

          if (record.qualityState === CONTROL_FAIL_QUALITY) {
            return {
              children: (
                <Row type="flex" justify="center">
                  <div className="azf-state-element qc-failed">
                    <img className="warning-icon" alt="" src={warningIcon} />
                    {record.qualityContent}
                  </div>
                </Row>
              ),
              props: {
                colSpan: 6
              }
            }
          }

          switch (record.state) {
            case PREPARE_RUN:
              return {
                children: (
                  <Row type="flex" justify="center" align="middle">
                    <div className={stateData[0].className}>
                      <Icon type="hourglass" />
                      {stateData[0].text}
                    </div>
                  </Row>
                ),
                props: {
                  colSpan: 6
                }
              }
            case RUNNING:
              return {
                children: (
                  <Row type="flex" justify="center" align="middle">
                    <div className={stateData[1].className}>
                      <Icon type="clock-circle-o" />
                      {stateData[1].text}
                    </div>
                  </Row>
                ),
                props: {
                  colSpan: 6
                }
              }
            case FAIL:
              return {
                children: (
                  <Row type="flex" justify="center">
                    <div className="azf-state-element run-failed">
                      <Icon type="close-circle" />
                      数据运行失败，
                      <div className="failed-button cursor-p" onClick={() => this.copyText(record.reportId)}>
                        点击复制错误信息
                      </div>
                      发送给管理员，将尽快为您解决问题。
                    </div>
                  </Row>
                ),
                props: {
                  colSpan: 6
                }
              }
            default:
              return (<div>{text}</div>)
          }
        }
      }, {
        title: (<div className="ta-r">Average_Length</div>),
        className: "ta-r",
        dataIndex: "averageLength",
        render: renderContent
      }, {
        title: (<div className="ta-r">Trimmomatic_Ratio</div>),
        className: "ta-r",
        dataIndex: "trimmomaticRatio",
        render: renderContent
      }, {
        title: (<div className="ta-r">High_Quality</div>),
        className: "ta-r",
        dataIndex: "highQuality",
        render: renderContent
      }, {
        title: (<div className="ta-r">Mapping_Rate</div>),
        className: "ta-r",
        dataIndex: "mappingRate",
        render: renderContent
      },{
        title: (<div className="ta-r">Unique_Reads</div>),
        className: "ta-r",
        dataIndex: "uniqueReads",
        render: renderContent
      }, {
        title: (<div className="ta-r">GC</div>),
        className: "ta-r",
        dataIndex: "gc",
        render: renderContent
      }, {
        title: (<div className="ta-r">Library_Quality</div>),
        className: "ta-r",
        dataIndex: "libraryQuality",
        render: renderContent
      }
    ]

    return (
      <div className="wrapper-box">
        <Table
          columns={columns}
          className="statistics-table"
          rowKey={record => record.reportId}
          dataSource={tableData.slice()}
          pagination={{
            pageSize: queryMap.limit,
            onChange: this.onPaginChange,
            defaultCurrent: 1,
            current: currentPageIndex,
            total: totalCount,
          }}
        />
      </div>
    )
  }
}

export default Index



// WEBPACK FOOTER //
// ./src/app/pages/azf/statistics/containers/DataTable.js